import React from 'react';
import PropTypes from 'prop-types';

function ShipmentTrackingTable({
  activityList,
}) {
  return (
    <table className="table table-striped mt-3">
      <thead>
        <tr>
          <th>Location</th>
          <th>Date</th>
          <th>Local Time</th>
          <th>Activity</th>
        </tr>
      </thead>
      <tbody>
        {activityList.map((activity) => (
          <tr key={activity.time + activity.description}>
            <td>{activity.locationDescription}</td>
            <td>{activity.date}</td>
            <td>{activity.time}</td>
            <td>{activity.description}</td>
          </tr>
        ))}

      </tbody>
    </table>
  );
}

ShipmentTrackingTable.propTypes = {
  activityList: PropTypes.arrayOf(PropTypes.shape({
    locationDescription: PropTypes.string,
    date: PropTypes.string,
    time: PropTypes.string,
    description: PropTypes.string,
  })),
};

ShipmentTrackingTable.defaultProps = {
  activityList: [],
};

export default ShipmentTrackingTable;
